import { createContext, useContext, useEffect, useMemo, useCallback } from "react";
import { translations, getByPath } from "@/i18n/translations";

const LanguageContext = createContext(null);

// FR only — language switching is disabled at this stage.
// Keeps the i18n architecture in place for a future reintroduction.
export function LanguageProvider({ children }) {
  const lang = "fr";

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
    // Clean any stale preference from previous sessions.
    try {
      window.localStorage.removeItem("horsindex-lang");
    } catch (storageErr) {
      // localStorage may be unavailable (e.g. private browsing); safe to ignore.
      if (process.env.NODE_ENV === "development") {
        console.warn("localStorage unavailable:", storageErr);
      }
    }
  }, []);

  const setLang = useCallback(() => {
    /* disabled — site is French only */
  }, []);

  const value = useMemo(() => {
    const dict = translations.fr;
    const t = (path, fallback = "") => {
      const v = getByPath(dict, path);
      if (v === undefined || v === null) return fallback || path;
      return v;
    };
    return { lang, setLang, t, dict };
  }, [setLang]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      lang: "fr",
      setLang: () => {},
      t: (p, fb = "") => fb || p,
      dict: translations.fr,
    };
  }
  return ctx;
}
